import { Button, Grid, Box, TextField, Autocomplete, Stack } from '@material-ui/core';
import { LoadingButton } from '@material-ui/lab';
import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik';
import Modal from '../../components/_dashboard/blog/ProjectModel';
import axios from 'axios';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import { useSnackbar } from 'notistack';



export default function AddMember({ projectId,prevProjectMembers,allTeamMembers,add,setAdd,setIsOpen,onRefresh, designOrder, onMembersAdded}) {
  //------------------------------------------------------------------------------------------
  const { enqueueSnackbar } = useSnackbar();
  const user = JSON.parse(window.localStorage.getItem('user'));

  const NewUserSchema = Yup.object().shape({
    projectMembers: Yup.array().required('Select projectMembers'),
  });
  const filteredTeamMembers = allTeamMembers?.filter(
    (teamMember) => !prevProjectMembers?.some(
      (projectMember) => projectMember.staff_id === teamMember.id
    )
  );
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
        projectMembers: [],
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        let apiUrl = '';
        if(designOrder){
          apiUrl = `design-order-job/add-member`
        }else{
          apiUrl = `project/add-project-member`
        }
        const payload = {
          ...values,
          projectId,
          userId: user?.user_id
        };
        const selectedMemberIds = (values?.projectMembers || [])
          .map((member) => Number(member?.id))
          .filter((id) => Number.isFinite(id) && id > 0);

        const response = await axios.post(`${REST_API_END_POINT}${apiUrl}`, payload, {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if(response?.data?.status === 1){
          if (typeof onMembersAdded === 'function' && selectedMemberIds.length > 0) {
            await onMembersAdded(selectedMemberIds);
          }
          resetForm();
          setAdd(false);
          setIsOpen(false);
          enqueueSnackbar(response?.data?.msg, { variant: 'success' });
          onRefresh(true);
        } else{
          enqueueSnackbar(response?.data?.msg, { variant: 'error' });
        }
      } catch (error) {
        console.error("Adding error - ", error);
        enqueueSnackbar('Failed to add members', { variant: 'error' });
        setErrors(error);
      } finally {
        setSubmitting(false);
      }
    }
  });

  const { errors, touched, handleSubmit, isSubmitting, setFieldValue } = formik;

  return (

        <Modal
          open={add}
          handleClose={() => {
            setAdd(false);
          }}
          modalTitle={'Add Member'}
        >
          <FormikProvider value={formik}>
            <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
              <Grid container justifyContent="center" >
                <Grid item xs={12} md={10}>
                  {/* <Card sx={{ p: 3 }}> */}
                  <Stack spacing={3}>
                    <Stack
                      direction={{ xs: 'column', sm: 'row' }}
                      spacing={{ xs: 3, sm: 2 }}
                    >
                      <Autocomplete
                        multiple
                        fullWidth
                        id="projectMembers"
                        options={filteredTeamMembers || []}
                        getOptionLabel={(state) => state.name}
                        onChange={(event, values) => {
                            const selectedIds = values.map((value) => {
                               return {id: value.id}
                            });
                            setFieldValue('projectMembers', selectedIds);
                        }}
                        // sx={{ width: 400 }}
                        renderInput={(params) => (
                          <TextField {...params} label="Select Reporter"
                            error={Boolean(touched.projectMembers && errors.projectMembers)}
                            helperText={touched.projectMembers && errors.projectMembers}
                          />
                        )}
                      />
                    </Stack>
                    <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                      <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
                        Save
                      </LoadingButton>
                      <Button variant="outlined" onClick={()=>{
                        setAdd(false)
                        // setIsEdit(false)
                        }}>
                        Cancel
                    </Button>
                    </Box>
                  </Stack>
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </Modal>

  );
}
